const FormationsDatas = [
    {id: '1',
    Title:'Titre Professionnel RNCP 6 (bac +3) Développeur Concepteur d\'Application',
    School: 'MyDigitalSchool',
    Date:'De Septembre 2021 à Juin 2022'},
    {id: '2',
    Title:'Titre Professionnel RNCP 5 (bac +2) Technicien Intégrateur Web',
    School: 'Buroscope',
    Date:'De Juillet 2020 à Juin 2021'},
    {id: '3'
    ,Title:'Formation Développeur d’Application Hybride',
    School: 'Buroscope',
    Date:'De Septembre 2019 à Février 2020'},
     ];

export default FormationsDatas;